// About.jsx

import React from "react";
import "./SealingContractors.css";
import { Link } from "react-router-dom";







export default function SealingContractors() {
  return (

    <div className="SealingContractors-page">
      <div className="SealingContractors-hero">
        <div className="SealingContractors-overlay">
          <h1>קבלני איטום</h1>
        </div>

<div>




</div>


</div>
    <div className="page4">
 <div className="breadcrumb4">
  <Link to="/">בית</Link> /{" "}
  <Link to="/SealingContractors">קבלני איטום</Link>
</div>
</div>

 <div className="article-page">
      <div className="article-container">



        <h1>
קבלני איטום שיכינו לכם את הבית לקראת החורף
        </h1>

        <p className="intro">
         כל מי שהתנסה אי פעם בחורף רטוב ודולף בתוך הבית פנימה, יודע כי איטום גגות זה ממש לא דבר מיותר. הוא ידאג עוד לפני הגשם הראשון כי החורף הזה הבית שלו יהיה מוגן! קבלני איטום מקצועיים יבצעו את המלאכה באופן הטוב ביותר!
        </p>

        <p>
         איטום גגות זה ממש לא מותרות. בבית שם ישנה דליפה של מי  הגשמים, כבר יודעים כי לפני הגשם הראשון חייבים לדאוג לאיטום מקצועי. כאשר החורף כבר פה, לעיתים זה כבר יהיה מאוחר מידי. על כן, חשוב לבדוק ולברר, לעשות את שיעורי הבית בתחום מבעוד מועד. כך שכאשר יגיע החורף אנחנו כבר נהיה מוכנים, מוגנים ואטומים...
        </p>

        <img
          src="/images/roof.jpg"
          alt="איטום גגות"
          className="main-image"
        />

        {/* כותרת אדומה */}
        <div className="section-title">
          <span className="square"></span>
          שיטות שונות לאיטום גגות
        </div>

        <p>
        בתחום של תיקון גגות קיימות כמה וכמה שיטות. יש את הזפת, השיטה הישנה והמוכרת, אותה כולנו מכירים. יש לזפת יתרונות לצד חסרונות וחשוב ללמוד ולהכיר אותם. יש את היריעות הביטומוניות שהפכו להיות פופולאריות מאוד בשנים האחרונות ויש גם חומרים אקריליים שונים. מדובר בחומרים טובים יותר או פחות אשר כל אחד מהם מתיימר ולמעשה מבטיח לנו חורף הכי יבש. אז במה כדאי לבחור?
        </p>

        {/* כותרת אדומה */}
        <div className="section-title">
          <span className="square"></span>
          קבלני איטום – לחורף הכי יבש שיש...
        </div>

        <p>
    אז האמת היא שהזפת היה והוא עדיין חומר מעולה והוא מצליח לאטום באופן מושלם את הגג והוא חוסם כל מעבר של מים אל תוך המבנה. הבעיה היא שלא תמיד ניתן לעשות שימוש בזפת ולא לכל גג הוא יכול  להתאים.
ישנם מקרים אשר בהם כבר נעשה איטום בעבר באמצעות חומרים אחרים כמו חומרים אקריליים שונים. אלו מנוגדים לחלוטין לזפת. במקרים מעין אלו לא ניתן יהיה להניח זפת וגם אם כן יעשו את זה, זה עלול אף לגרום לנזק.
יריעות ביטומוניות לעומת זאת זהו פתרון מעולה כאשר אנחנו רואים כי בשנים האחרונות, בוחרים רבים לאטום דווקא בהם.
אך כמו בכל תחום, גם כאן, חשוב לשים לב אל מי פונים וכיצד מבצעים את העבודה.
        </p>

    

        {/* כותרת אדומה */}
        <div className="section-title">
          <span className="square"></span>
          שימו לב שאף אחד לא עושה כסף קל על הגג שלכם...
        </div>

        <p>
    בתחום של איטום גגות, ממש כמו בתחומים אחרים, קיימת הרבה שרלטנות. ישנם חובבנים שמנסים לעשות כסף קל ומציעים לאטום את הגג במחירי היכרות.
חשוב לדעת כשמדובר בזפת, חובה לברר כי מדובר בזפת תקני. חשוב לברר גם כי הצוות מנוסה ומיומן, כמו כן יש לבדוק האם יש לחברה שם טוב והלקוחות שלהם מרוצים מהעבודות שלהם.
        </p>

      </div>
    </div>





      </div>
  );
}


